import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import CheckIcon from '../../../../../assets/icons/check.svg';
import {Currency, getPriceString} from '../../../../../utils/money';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, payment, program, refund} = contexts;

  const data: EventData = {};

  if (payment && actor) {
    data.avatar = program?.avatar;
    data.avatarPlaceholder = program?.title;

    data.title = i18n.t('notifications:payment_refunded.title', {
      actorName: actor.name,
      price: getPriceString({
        currency: Currency[payment.currency],
        price: refund ? refund.amount : payment.amount,
      }),
    });
  }

  data.icon = CheckIcon;
  data.iconGradient = 'success';

  return data;
};
